import { AntragsLimitService } from '@eBeihilfe/einreichung-shared/services';
import { Component, inject, input } from '@angular/core';
import { EinreichungStep } from '@ebeihilfe/einreichung-old';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-einreichung-stepper-with-info',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: false,
})
export class StepperComponent {
  private readonly antragsLimitService = inject(AntragsLimitService);

  public antragsLimit = this.antragsLimitService.getAntragsLimit();
  public currentStep = input.required<EinreichungStep>();
  public einreichungStep = EinreichungStep;
}
